/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  Cache200One,
  Cache200Three,
  Cache200Two,
  CacheParams,
  CachePathParameters,
  Caches200One,
  Caches200Three,
  Caches200Two,
  ConfigurationProperties200One,
  ConfigurationProperties200Three,
  ConfigurationProperties200Two,
  ConfigurationPropertiesWithPrefix200One,
  ConfigurationPropertiesWithPrefix200Three,
  ConfigurationPropertiesWithPrefix200Two,
  ConfigurationPropertiesWithPrefixPathParameters,
  Environment200One,
  Environment200Three,
  Environment200Two,
  EnvironmentEntry200One,
  EnvironmentEntry200Three,
  EnvironmentEntry200Two,
  EnvironmentEntryPathParameters,
  EnvironmentParams,
  Health200One,
  Health200Three,
  Health200Two,
  Info200One,
  Info200Three,
  Info200Two,
  Links200One,
  Links200Three,
  Links200Two,
  ListNames200One,
  ListNames200Three,
  ListNames200Two,
  LoggerLevels200One,
  LoggerLevels200Three,
  LoggerLevels200Two,
  LoggerLevelsPathParameters,
  Loggers200One,
  Loggers200Three,
  Loggers200Two,
  Metric200One,
  Metric200Three,
  Metric200Two,
  MetricParams,
  MetricPathParameters,
  ThreadDump200Four,
  ThreadDump200One,
  ThreadDump200Three,
  ThreadDump200Two,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getManagement = () => {
  /**
   * @summary Actuator root web endpoint
   */
  const links = () => {
    return customInstance<Links200One | Links200Two | Links200Three>({
      url: `/management`,
      method: "GET",
    });
  };
  /**
   * @summary Actuator web endpoint 'threaddump'
   */
  const threadDump = () => {
    return customInstance<
      ThreadDump200One | ThreadDump200Two | ThreadDump200Three | ThreadDump200Four
    >({ url: `/management/threaddump`, method: "GET" });
  };
  /**
   * @summary Actuator web endpoint 'metrics'
   */
  const listNames = () => {
    return customInstance<ListNames200One | ListNames200Two | ListNames200Three>({
      url: `/management/metrics`,
      method: "GET",
    });
  };
  /**
   * @summary Actuator web endpoint 'metrics-requiredMetricName'
   */
  const metric = ({ requiredMetricName }: MetricPathParameters, params?: MetricParams) => {
    return customInstance<Metric200One | Metric200Two | Metric200Three>({
      url: `/management/metrics/${requiredMetricName}`,
      method: "GET",
      params,
    });
  };
  /**
   * @summary Actuator web endpoint 'loggers'
   */
  const loggers = () => {
    return customInstance<Loggers200One | Loggers200Two | Loggers200Three>({
      url: `/management/loggers`,
      method: "GET",
    });
  };
  /**
   * @summary Actuator web endpoint 'loggers-name'
   */
  const loggerLevels = ({ name }: LoggerLevelsPathParameters) => {
    return customInstance<LoggerLevels200One | LoggerLevels200Two | LoggerLevels200Three>({
      url: `/management/loggers/${name}`,
      method: "GET",
    });
  };
  /**
   * @summary Actuator web endpoint 'info'
   */
  const info = () => {
    return customInstance<Info200One | Info200Two | Info200Three>({
      url: `/management/info`,
      method: "GET",
    });
  };
  /**
   * @summary Actuator web endpoint 'health'
   */
  const health = () => {
    return customInstance<Health200One | Health200Two | Health200Three>({
      url: `/management/health`,
      method: "GET",
    });
  };
  /**
   * @summary Actuator web endpoint 'env'
   */
  const environment = (params?: EnvironmentParams) => {
    return customInstance<Environment200One | Environment200Two | Environment200Three>({
      url: `/management/env`,
      method: "GET",
      params,
    });
  };
  /**
   * @summary Actuator web endpoint 'env-toMatch'
   */
  const environmentEntry = ({ toMatch }: EnvironmentEntryPathParameters) => {
    return customInstance<
      EnvironmentEntry200One | EnvironmentEntry200Two | EnvironmentEntry200Three
    >({ url: `/management/env/${toMatch}`, method: "GET" });
  };
  /**
   * @summary Actuator web endpoint 'configprops'
   */
  const configurationProperties = () => {
    return customInstance<
      | ConfigurationProperties200One
      | ConfigurationProperties200Two
      | ConfigurationProperties200Three
    >({ url: `/management/configprops`, method: "GET" });
  };
  /**
   * @summary Actuator web endpoint 'configprops-prefix'
   */
  const configurationPropertiesWithPrefix = ({
    prefix,
  }: ConfigurationPropertiesWithPrefixPathParameters) => {
    return customInstance<
      | ConfigurationPropertiesWithPrefix200One
      | ConfigurationPropertiesWithPrefix200Two
      | ConfigurationPropertiesWithPrefix200Three
    >({ url: `/management/configprops/${prefix}`, method: "GET" });
  };
  /**
   * @summary Actuator web endpoint 'caches'
   */
  const caches = () => {
    return customInstance<Caches200One | Caches200Two | Caches200Three>({
      url: `/management/caches`,
      method: "GET",
    });
  };
  /**
   * @summary Actuator web endpoint 'caches-cache'
   */
  const cache = ({ cache }: CachePathParameters, params?: CacheParams) => {
    return customInstance<Cache200One | Cache200Two | Cache200Three>({
      url: `/management/caches/${cache}`,
      method: "GET",
      params,
    });
  };
  return {
    links,
    threadDump,
    listNames,
    metric,
    loggers,
    loggerLevels,
    info,
    health,
    environment,
    environmentEntry,
    configurationProperties,
    configurationPropertiesWithPrefix,
    caches,
    cache,
  };
};
export type LinksResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getManagement>["links"]>>
>;
export type ThreadDumpResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getManagement>["threadDump"]>>
>;
export type ListNamesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getManagement>["listNames"]>>
>;
export type MetricResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getManagement>["metric"]>>
>;
export type LoggersResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getManagement>["loggers"]>>
>;
export type LoggerLevelsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getManagement>["loggerLevels"]>>
>;
export type InfoResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getManagement>["info"]>>>;
export type HealthResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getManagement>["health"]>>
>;
export type EnvironmentResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getManagement>["environment"]>>
>;
export type EnvironmentEntryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getManagement>["environmentEntry"]>>
>;
export type ConfigurationPropertiesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getManagement>["configurationProperties"]>>
>;
export type ConfigurationPropertiesWithPrefixResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getManagement>["configurationPropertiesWithPrefix"]>>
>;
export type CachesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getManagement>["caches"]>>
>;
export type CacheResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getManagement>["cache"]>>
>;
